<template>
  <v-card
    v-if="name && url"
    @click="onShowFile()"
    class="d-flex flex-column overflow-hidden card-file"
    height="100%"
  >
    <template v-if="fileExtension === 'pdf'">
      <PdfPreviewWidget :id="file" :url="url" />
    </template>

    <template v-if="['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension)">
      <img class="d-block responsive" :src="url" />
    </template>

    <template v-if="fileExtension === 'mp4'">
      <video
        class="d-block responsive"
        preload="metadata"
        crossorigin="anonymous"
        webkit-playsinline
        playsinline
        controls
      >
        <source :src="url" type="video/mp4" />
        Seu navegador não suporta vídeo HTML5.
      </video>
    </template>

    <template
      v-if="
        ['doc', 'docx', 'xls', 'xslx', 'ppt', 'pptx'].includes(fileExtension)
      "
    >
      <div class="d-flex align-center justify-center responsive">
        <v-icon size="56"> mdi-file-document-outline </v-icon>
      </div>
    </template>

    <v-divider />

    <v-sheet
      class="d-flex flex-column justify-center pa-3 pa-sm-4"
      color="transparent"
      height="100%"
    >
      <div
        class="black--text text-caption text-sm-body-2 text-center font-weight-medium card-file-name"
      >
        {{ name }}
      </div>

      <div
        class="secondary--text text--lighten-2 text-caption text-center font-weight-regular mt-1"
      >
        {{ formatDate(created_at) }}
      </div>
    </v-sheet>
  </v-card>
</template>

<script>
import PdfPreviewWidget from "@/components/widgets/PdfPreview.vue";
import formatDate from "@/utils/formatDate";

export default {
  components: { PdfPreviewWidget },
  props: {
    name: String,
    url: String,
    file: String,
    created_at: String,
  },
  computed: {
    fileExtension() {
      return this.file.split(".").pop().toLowerCase();
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    async onShowFile() {
      this.isLoadingFile = true;

      if (this.url) {
        const response = await fetch(this.url);

        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = this.name || this.url;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }

      this.isLoadingFile = false;
    },
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.card-file {
  background-color: #ffffff;
  border: 1px solid #ddd6d2 !important;
  border-radius: 16px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0 0 0 / 0.1) !important;
  transition: all 0.1s linear;

  @media screen and (max-width: 599.9px) {
    border-radius: 8px !important;
    padding: 12px;
  }

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -4px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-6px);
  }

  &-name {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

.card-file-pdf::v-deep {
  canvas {
    aspect-ratio: 16 / 9;
    height: auto !important;
    object-fit: cover;
    object-position: top;
  }
}

.responsive {
  aspect-ratio: 16 / 9;
  height: auto !important;
  object-fit: cover;
  object-position: top;
  width: 100%;
}
</style>
